/**
 * Module « scan » — contrôle d’accès du soir (SCAN-01 à SCAN-08).
 *
 * Routes montées sous `/scan` par `router.tsx`, dans la coque sombre
 * `LayoutScan` (session staff, rôle guichet ou admin) :
 *
 *   /scan                              choix de la représentation (SCAN-01)
 *   /scan/:representation              caméra, verdicts, compteur (SCAN-02…04, 07)
 *   /scan/:representation/recherche    filet par nom, admission manuelle (SCAN-05)
 *   /scan/:representation/emargement   liste imprimable, mode dégradé (SCAN-06)
 *
 * Les admissions alimentent l’historique « pièces vues » du portail (SCAN-08) :
 * c’est le serveur qui l’écrit à chaque admission ; cet écran n’a rien de plus à
 * faire que d’admettre au bon moment.
 */

import { lazy } from 'react'
import { Outlet, type RouteObject } from 'react-router'

import { useConfigurationPwa } from './pwa'

// Espace `/scan` : coque autonome (PWA de contrôle), chargée seulement quand on
// y navigue (ARCHITECTURE §9.4). `LayoutScan` porte le `<Suspense>` de repli.
const PageRepresentations = lazy(() =>
  import('./PageRepresentations').then((m) => ({ default: m.PageRepresentations })),
)
const PageControle = lazy(() => import('./PageControle').then((m) => ({ default: m.PageControle })))
const PageRecherche = lazy(() => import('./PageRecherche').then((m) => ({ default: m.PageRecherche })))
const PageEmargement = lazy(() =>
  import('./PageEmargement').then((m) => ({ default: m.PageEmargement })),
)

/**
 * Coque commune aux écrans de scan : branche le manifeste PWA et le service
 * worker (s’ils sont servis à la racine) et occupe toute la hauteur restante —
 * l’action principale ne doit jamais demander de défilement.
 */
function CoqueScan() {
  useConfigurationPwa()
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Outlet />
    </div>
  )
}

export const routesScan: RouteObject[] = [
  {
    element: <CoqueScan />,
    children: [
      { index: true, element: <PageRepresentations /> },
      { path: ':representation', element: <PageControle /> },
      { path: ':representation/recherche', element: <PageRecherche /> },
      { path: ':representation/emargement', element: <PageEmargement /> },
    ],
  },
]
